<section class="dialog-section">
  <div class="dialog-container">
    <div class="dialog-card">
      <!-- Header -->
      <div class="dialog-header">
        <h1 class="dialog-title">{{ "common.welcomeBack" | translate }}</h1>
      </div>

      <!-- Content -->
      <div class="dialog-content">
        <p class="dialog-description">
          {{ "page.questionnaire.draftFound" | translate }}
        </p>
      </div>

      <!-- Actions -->
      <div class="dialog-actions">
        <button class="danger-button" (click)="close('restart')">
          {{ "button.restart" | translate }}
        </button>
        <button cdkFocusInitial class="primary-button" (click)="close('continue')">
          {{ "button.resume" | translate }}
        </button>
      </div>
    </div>
  </div>
</section>
